/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useBlobDownload
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents, { Events, Messages } from '@veritable/common/utils/appEvents';
import { downloadBlobFile } from '@veritable/common/utils';

interface IHookParams {
	title?: string;
	contentType?: string;
}

interface IBlobDownloadParams {
	blobId: string;
	blobCategory: S3BlobCategory;
	entityType?: EntityTypeEnum;
}

const useBlobDownload = ({ title, contentType }: IHookParams): UseMutationResult<void, IAxiosError, IBlobDownloadParams, void> => {
	return useMutation({
		mutationFn: async (model: IBlobDownloadParams) => {
			const { data } = await api.BlobDataApi.downloadBlob(model, { responseType: 'blob' });
			downloadBlobFile(data as BlobPart, title || 'blob-download', contentType || 'application/pdf', 'download');
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess('Download complete');
		},
		onMutate: () => {
			AppEvents.publish(Events.Loading, Messages.DownloadingFile);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useBlobDownload;
